import React, { Component, Fragment, createRef } from "react";
import { legacy_connect as connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { Dropdown } from "component/menu";
import { TableList } from "component/list";
import * as queryString from "query-string";
import { fromJS } from "immutable";
import { isEqual } from "lodash";

import { currencyFormatter } from "utils/currencyHelper";

import "containers/RoundHistoryPerGame/styles.scss";
import { CommonModalHeader } from "component/common";
import { ReactComponent as SortArrowDown } from "assets/icons/sort-arrow-down.svg";
import { ReactComponent as SortArrowUp } from "assets/icons/sort-arrow-up.svg";
import { withTranslation } from "react-i18next";
import { RoundDetails } from "component/details";
import ScrollDirectionTracker from "utils/ScrollDirectionTracker";

class RoundHistoryPerGame extends Component {
  constructor(props) {
    super(props);
    this.titleRef = createRef();
    this.titleMeasureRef = createRef();
    this.fetchList = this._fetchList.bind(this);
    this.fetchGameRounds = this._fetchGameRounds.bind(this);
    this.renderImage = this._renderImage.bind(this);
    this.fetchAvailableMonths = this._fetchAvailableMonths.bind(this);
    this.onSort = this._onSort.bind(this);
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.renderSelectedRow = this._renderSelectedRow.bind(this);
    this.getMonthFromUrl = this._getMonthFromUrl.bind(this);
    this.handleMonthChange = this._handleMonthChange.bind(this);
    this.setHistoryMonth = this._setHistoryMonth.bind(this);
    this.canPersistHistoryMonth = this._canPersistHistoryMonth.bind(this);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.checkTitleLength = this._checkTitleLength.bind(this);

    this.rootRef = createRef();
    this.scrollTracker = new ScrollDirectionTracker({
      scrollContainer: () => this.rootRef.current,
      threshold: 8,
      topOffset: 20,
      onChange: (isHidden) => this.setState({ isNavHidden: isHidden }),
    });

    this.state = {
      isNavHidden: false,
      pendingScrollReset: false,
      availableMonthsLink: null,
      availableMonths: null,
      selectedMonthIndex: null,
      selectedMonthLocalIndex: null,
      isLoading: false,
      isLoadingNext: false,
      roundHistoryPerGameLink: null,
      roundHistoryPerGame: null,
      launchRealLink: null,
      listComplete: null,
      links: null,
      selectedItem: null,
      roundDetails: null,
      showTitle: false,
      isLongTitle: false,
      sort: {
        orderBy: "DESC",
        sortBy: "initiatedDate",
      },
    };
  }

  _getTitleText() {
    if (this.state.roundHistoryPerGame) {
      return this.state.roundHistoryPerGame.get("title") || "";
    }
    if (this.props.gameItem) {
      return this.props.gameItem.get("name") || "";
    }
    return "";
  }

  _setupTitleResizeObserver() {
    if (typeof ResizeObserver === "undefined" || !this.titleRef.current) {
      return;
    }
    if (this._titleResizeObserver) {
      this._titleResizeObserver.disconnect();
    }
    this._titleResizeObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(() => this.checkTitleLength());
    });
    this._titleResizeObserver.observe(this.titleRef.current);
  }

  _checkTitleLength() {
    if (!this.titleMeasureRef.current || !this.titleRef.current) return;

    const measureEl = this.titleMeasureRef.current;
    const rowEl = this.titleRef.current;

    const naturalWidth = measureEl.offsetWidth;
    const rowWidth = rowEl.clientWidth;
    if (naturalWidth === 0 || rowWidth === 0) return;

    const hasImage = !!rowEl.querySelector("img");
    const imageWidth = hasImage ? 72 : 0;

    const buttonGroupEl = rowEl.querySelector(
      ".button-group-container .button-group",
    );
    const buttonWidth = buttonGroupEl ? buttonGroupEl.offsetWidth : 0;

    const marginAndBuffer = 25;
    const availableWidth =
      rowWidth - imageWidth - buttonWidth - marginAndBuffer;

    const isLong = naturalWidth > availableWidth;

    if (isLong !== this.state.isLongTitle) {
      this.setState({ isLongTitle: isLong });
    }
  }

  _getMonthFromUrl(url) {
    if (!url) return null;

    try {
      if (url.startsWith("/") || !url.includes("://")) {
        const parser = document.createElement("a");
        parser.href = url;
        url = parser.href;
      }

      const urlObj = new URL(url);
      return urlObj.searchParams.get("month");
    } catch (error) {
      console.error("Error parsing URL:", error);

      const match = url.match(/[?&]month=([^&]*)/);
      return match ? match[1] : null;
    }
  }

  _canPersistHistoryMonth() {
    return !this.props.isModal && !!this.props.location;
  }

  _setHistoryMonth(month, monthId) {
    if (!this.canPersistHistoryMonth()) return;

    const params = queryString.parse(this.props.location.search);

    if (month && monthId) {
      params.historyMonth = month;
      params.historyMonthId = monthId;
    } else {
      delete params.historyMonth;
      delete params.historyMonthId;
    }

    this.props.history.replace(
      `${this.props.location.pathname}?${queryString.stringify(params)}`,
    );
  }

  _handleMonthChange(id, name, index) {
    const selectedMonth = this.state.availableMonths.get(index);
    if (selectedMonth) {
      this.setState({
        selectedMonthIndex: index,
        selectedMonthLocalIndex: index,
        pendingScrollReset: true,
      });

      this.setHistoryMonth(selectedMonth.get("name"), selectedMonth.get("id"));
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.titleRef.current) {
                this.setState({
                  showTitle: false,
                });
              }
            } else {
              if (this.titleRef.current) {
                this.setState({
                  showTitle: true,
                });
              }
            }
          });
        },
        {
          rootMargin: "50px 50px 50px 50px",
          threshold: 0.1,
        },
      );
      observer.observe(this.titleRef.current);
    }
  }

  _onClickPrevious() {
    if (this.props.isModal && this.props.onClose) {
      this.props.onClose();
    } else {
      this.props.history.goBack();
    }
  }

  _onCloseClickHandler() {
    if (this.props.isModal && this.props.onClose) {
      this.props.onClose();
    } else {
      this.props.navigateTo(this.props.location.pathname);
    }
  }

  _fetchAvailableMonths() {
    this.setState({
      availableMonths: null,
      selectedMonthIndex: null,
    });

    this.props
      .fetchGameHistoryAvailableMonths(this.state.availableMonthsLink)
      .then((response) => {
        const respObj = fromJS(response);

        let availableMonths = respObj;
        if (respObj && respObj.has && respObj.has("items")) {
          availableMonths = respObj.get("items");
        }

        this.props.setGameHistoryAvailableMonths(availableMonths);

        const availableMonthsLinkHref = this.state.availableMonthsLink
          ? this.state.availableMonthsLink.get("href")
          : null;
        const urlMonth = this._getMonthFromUrl(availableMonthsLinkHref);

        let selectedMonthIndex = 0;
        if (urlMonth && availableMonths && availableMonths.size > 0) {
          const urlMonthIndex = availableMonths.findIndex(
            (month) => month && month.get("id") === urlMonth,
          );

          if (urlMonthIndex >= 0) {
            selectedMonthIndex = urlMonthIndex;
          }
        }

        if (
          this.props.historyMonthId &&
          availableMonths &&
          availableMonths.size > 0
        ) {
          const historyMonthIndex = availableMonths.findIndex(
            (month) => month && month.get("id") === this.props.historyMonthId,
          );

          if (historyMonthIndex >= 0) {
            selectedMonthIndex = historyMonthIndex;
          }
        }

        if (
          !this.canPersistHistoryMonth() &&
          this.state.selectedMonthLocalIndex !== null
        ) {
          selectedMonthIndex = this.state.selectedMonthLocalIndex;
        }

        this.setState({
          availableMonths: availableMonths,
          selectedMonthIndex:
            availableMonths && availableMonths.size === 0
              ? null
              : selectedMonthIndex,
        });
      });
  }

  _fetchList(page) {
    if (!page) {
      this.setState({
        roundHistoryPerGame: null,
      });
    }

    if (
      (this.state.availableMonths && this.state.availableMonths.size === 0) ||
      (this.state.roundHistoryPerGame &&
        page > this.state.roundHistoryPerGame.get("totalPages"))
    ) {
      this.setState({
        listComplete: true,
      });
      return;
    }

    this.setState({
      isLoading: true,
      listComplete: false,
    });

    let selectedMonth =
      this.state.availableMonths &&
      this.state.availableMonths.get(this.state.selectedMonthIndex);

    let params = {
      month: selectedMonth && selectedMonth.get("id"),
      page: page,
      orderBy: this.state.sort ? this.state.sort.orderBy : null,
      sortBy: this.state.sort ? this.state.sort.sortBy : null,
    };
    this.props
      .fetchGameRoundHistoryPerGame(this.state.roundHistoryPerGameLink, params)
      .then((response) => {
        let newgameRoundHistory = response;

        if (this.state.roundHistoryPerGame) {
          newgameRoundHistory = newgameRoundHistory.setIn(
            ["items"],
            this.state.roundHistoryPerGame
              .get("items")
              .concat(response.getIn(["items"])),
          );
        }

        this.props.setGameRoundHistoryPerGame(newgameRoundHistory);
        this.setState({
          roundHistoryPerGame: newgameRoundHistory,
          isLoading: false,
        });
      });
  }

  _fetchGameRounds(link, params) {
    this.setState({
      roundDetails: null,
    });
    this.props.fetchGameRounds(link, params).then((response) => {
      this.setState({
        roundDetails: response && response.toJSON ? response.toJSON() : null,
      });
      this.props.setGameRounds(response);
    });
  }

  _onSort(value) {
    let orderBy;

    if (value !== this.state.sort.sortBy) orderBy = "DESC";
    else if (this.state.sort.orderBy === "DESC") orderBy = "ASC";
    else if (this.state.sort.orderBy === "ASC") orderBy = "DESC";

    let newSort = {
      sortBy: value,
      orderBy,
    };

    this.setState({
      sort: newSort,
    });
  }

  fetchGameRoundHistoryPerGameRoute(link) {
    this.setState({
      availableMonthsLink: null,
      roundHistoryPerGameLink: null,
      launchRealLink: null,
    });
    this.props.fetchGameRoundHistoryPerGameRoute(link).then((response) => {
      let availableMonthsLink =
        response &&
        response.find((link) => link && link.get("rel") === "available-months");
      let roundHistoryPerGameLink =
        response &&
        response.find(
          (link) => link && link.get("rel") === "round-history-per-game",
        );
      let launchRealLink =
        response &&
        response.find((link) => link && link.get("rel") === "launch.real");

      this.setState({
        availableMonthsLink,
        roundHistoryPerGameLink,
        launchRealLink,
      });
      return this.props.setGameRoundHistoryPerGameRoute(response);
    });
  }

  componentDidMount() {
    this.scrollTracker.start();

    if (
      !this.props.isModal &&
      this.props.modalRel === "round-history-per-game.links"
    ) {
      this.initObserver();
    }

    if (this.props.RoundHistoryPerGameLink || this.props.roundHistoryLink) {
      const link =
        this.props.RoundHistoryPerGameLink || this.props.roundHistoryLink;
      this.fetchGameRoundHistoryPerGameRoute(link);
    }

    this._setupTitleResizeObserver();
    this.checkTitleLength();
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    if (this.rootRef.current) {
      this.scrollTracker.ensureAttached();
    }

    if (
      !this.props.isModal &&
      prevProps.modalRel !== this.props.modalRel &&
      this.props.modalRel === "round-history-per-game.links"
    ) {
      this.initObserver();
    }

    const currentLink =
      this.props.RoundHistoryPerGameLink || this.props.roundHistoryLink;
    const prevLink =
      prevProps.RoundHistoryPerGameLink || prevProps.roundHistoryLink;

    if (!isEqual(prevLink, currentLink) && currentLink) {
      this.fetchGameRoundHistoryPerGameRoute(currentLink);
    }

    if (!isEqual(prevLink, currentLink) && !currentLink) {
      this.setState({
        availableMonthsLink: null,
        availableMonths: null,
        isLoading: false,
        isLoadingNext: false,
        roundHistoryPerGameLink: null,
        roundHistoryPerGame: null,
        listComplete: null,
        links: null,
        selectedItem: null,
      });
    }

    if (
      !isEqual(prevState.availableMonthsLink, this.state.availableMonthsLink) &&
      this.state.availableMonthsLink
    ) {
      this.fetchAvailableMonths();
    }

    if (
      prevState.selectedMonthIndex !== this.state.selectedMonthIndex &&
      this.state.selectedMonthIndex !== null
    ) {
      this.fetchList();
    }

    if (this.state.pendingScrollReset && !prevState.pendingScrollReset) {
      this.setState({ pendingScrollReset: false });
      requestAnimationFrame(() => {
        const historyContainer = this.rootRef.current;
        if (historyContainer) {
          try {
            historyContainer.scrollTo({ top: 0, behavior: "smooth" });
          } catch (err) {
            historyContainer.scrollTop = 0;
          }
        }
      });
    }

    if (prevState.sort !== this.state.sort) {
      this.fetchList();
    }

    const prevTitle = prevState.roundHistoryPerGame
      ? prevState.roundHistoryPerGame.get("title")
      : prevProps.gameItem
        ? prevProps.gameItem.get("name")
        : "";
    const currTitle = this._getTitleText();
    const launchLinkChanged =
      prevState.launchRealLink !== this.state.launchRealLink;
    if (prevTitle !== currTitle || launchLinkChanged) {
      this._setupTitleResizeObserver();
      this.checkTitleLength();
    }
  }

  componentWillUnmount() {
    this.scrollTracker.stop();

    if (this._titleResizeObserver) {
      this._titleResizeObserver.disconnect();
      this._titleResizeObserver = null;
    }
  }

  setLabel(id) {
    let { t } = this.props;

    try {
      switch (id) {
        case "completedDate":
          return <div>{t("completed")}</div>;
        case "totalPayout":
        case "totalBet":
          return <div className="text-end">{t(id)}</div>;
        case "initiatedDate":
          let AArrow =
            this.state.sort.orderBy === "DESC" ? SortArrowDown : SortArrowUp;
          return (
            <span
              className={`label-with-sort ${
                this.state.sort.sortBy === "initiatedDate" ? "selected" : ""
              }`}
            >
              {t(id)}
              {this.state.sort.sortBy === "initiatedDate" && (
                <div className="arrow nopadding d-none align-items-center">
                  <AArrow />
                </div>
              )}
            </span>
          );
        default:
          return <div>{t(id)}</div>;
      }
    } catch {
      return null;
    }
  }

  setValue(item) {
    switch (item.id) {
      case "links":
        return JSON.stringify(item.value);
      case "totalPayout":
      case "totalBet":
        return this.renderAmount(item);
      case "completedDate":
      case "initiatedDate":
        return this.renderDate(item);
      default:
        return item.value;
    }
  }

  _renderSelectedRow() {
    return (
      <RoundDetails
        details={this.state.roundDetails}
        isModal={this.props.isModal}
        onViewResultClick={() => {
          if (this.props.isModal && this.props.onViewResultClick) {
            this.props.onViewResultClick(this.state.roundDetails.gameResultUrl);
          } else {
            let params = {
              modalRel: "game-round-result",
              gameResultUrl: btoa(this.state.roundDetails.gameResultUrl),
            };
            let newLoc = `${this.props.location.pathname}?${queryString.stringify(
              params,
            )}`;
            this.props.navigateTo(newLoc);
          }
        }}
      />
    );
  }

  renderAmount(item) {
    let value = currencyFormatter(item.value, {
      symbol: this.props.symbol,
      decimalPlaces: this.props.decimalPlaces,
    });

    return <div className="text-end">{value}</div>;
  }

  renderDate(item) {
    if (item.value === "" || !item.value) return null;

    const date = item.value.split(" ");
    return (
      <Fragment>
        <span className="d-flex">{`${date[0]} ${date[1]} `}</span>
        <span className="d-flex">{`${date[2]}`}</span>
      </Fragment>
    );
  }

  renderHeaderSkeleton(key) {
    switch (key) {
      case 3:
      case 4:
        return (
          <th key={key} className="text-end">
            <span className="dummy">loading</span>
          </th>
        );
      default:
        return (
          <th key={key}>
            <span className="dummy">loading</span>
          </th>
        );
    }
  }

  renderSkeleton(key) {
    switch (key) {
      case 0:
        return (
          <td key={key}>
            <span className="dummy">loading</span>
            <br />
            <span className="dummy">loading</span>
          </td>
        );
      case 1:
        return (
          <td key={key}>
            <span className="dummy">XXXXXXXXXXXXXXXXXXXXX</span>
          </td>
        );
      case 3:
      case 4:
        return (
          <td key={key} className="text-end">
            <span className="dummy">loading</span>
          </td>
        );
      default:
        return (
          <td key={key}>
            <span className="dummy">loading</span>
          </td>
        );
    }
  }

  _renderImage() {
    const { gameItem } = this.props;
    if (!gameItem) {
      return null;
    }
    let imgUrl;

    imgUrl = gameItem.getIn(["images", "logoSquareUrl"]);

    if (!imgUrl) {
      imgUrl = gameItem.getIn(["game", "images", "logoSquareUrl"]);
    }

    if (!imgUrl) {
      return null;
    }

    let urlObj = queryString.parseUrl(imgUrl);
    urlObj.query.width = 56;
    urlObj.query.theme = "dark";
    let newImgUrl = `${urlObj.url}?${queryString.stringify(urlObj.query)}`;

    return <img src={newImgUrl} alt="game icon" data-testid="game-icon" />;
  }

  _onGameItemClickHandler(game, rel) {
    this.setState({
      loadingGameRel: null,
    });

    let gameId =
      game.get("gameId") ||
      game.get("id") ||
      game.getIn(["game", "id"]) ||
      game.getIn(["game", "gameId"]);

    let nav = this.props.link ? this.props.link.get("rel") : null;

    if (!gameId) {
      return;
    }

    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response && response.location) {
        this.props.navigateTo(response.location);
      } else if (response && response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  render() {
    const { t, isModal } = this.props;
    const link =
      this.props.RoundHistoryPerGameLink || this.props.roundHistoryLink;

    if (!link) return null;

    const titleText = this._getTitleText();

    return (
      <div
        ref={this.rootRef}
        className={`round-history-per-game ${isModal ? "modal-mode modal-open" : ""}`}
      >
        {!isModal ? (
          <CommonModalHeader
            title={
              this.state.roundHistoryPerGame
                ? this.state.roundHistoryPerGame.get("title")
                : ""
            }
            showTitle={this.state.showTitle}
            onClickPrevious={this.onClickPrevious}
            onCloseClickHandler={this.onCloseClickHandler}
          />
        ) : (
          <div className="text-end">
            <span
              className="btn close-btn"
              onClick={this.props.onClose || this.onCloseClickHandler}
            >
              {t("close")}
            </span>
          </div>
        )}

        <div
          className={`title row${this.state.isLongTitle ? " long-title" : ""}`}
          ref={this.titleRef}
        >
          {titleText && (
            <span ref={this.titleMeasureRef} aria-hidden="true">
              {titleText}
            </span>
          )}

          {!this.state.roundHistoryPerGame && !this.props.gameItem && (
            <>
              <div className="col-auto nopadding">{this.renderImage()}</div>
              <div className="col nopadding d-flex align-items-center">
                <div>
                  <div className="dummy">loading</div>
                  <div className="subtitle dummy">loading</div>
                </div>
              </div>
            </>
          )}
          {this.state.roundHistoryPerGame && (
            <>
              <div className="col-auto nopadding">{this.renderImage()}</div>
              <div
                className={`${
                  this.state.roundHistoryPerGame ? "col" : "d-none"
                } nopadding d-flex align-items-center`}
              >
                <div>
                  <div data-testid="game-title">
                    {this.state.roundHistoryPerGame
                      ? this.state.roundHistoryPerGame.get("title")
                      : ""}
                  </div>
                  <div className="subtitle" data-testid="game-provider-name">
                    {this.state.roundHistoryPerGame
                      ? this.state.roundHistoryPerGame.get("subtitle")
                      : ""}
                  </div>
                </div>
              </div>
            </>
          )}
          {this.props.gameItem && !this.state.roundHistoryPerGame && (
            <>
              <div className="col-auto nopadding">{this.renderImage()}</div>
              <div
                className={`${
                  this.props.gameItem ? "col" : "d-none"
                } nopadding d-flex align-items-center`}
              >
                <div>
                  <div data-testid="game-title">
                    {this.props.gameItem ? this.props.gameItem.get("name") : ""}
                  </div>
                  <div className="subtitle" data-testid="game-provider-name">
                    {this.props.gameItem
                      ? this.props.gameItem.get("provider")
                      : ""}
                  </div>
                </div>
              </div>
            </>
          )}
          {!this.props.isModal && this.state.launchRealLink && (
            <div className="col-auto nopadding button-group-container">
              <div className="button-group">
                {this.state.launchRealLink && (
                  <button
                    className="btn btn-danger w-100"
                    data-testid="play-now-button"
                    onClick={(event) => {
                      event.stopPropagation();
                      let rel = this.state.launchRealLink.get("rel");
                      this.onGameItemClickHandler(this.props.gameItem, rel);
                    }}
                  >
                    {t("playNow")}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
        <div
          className={`header-sub-title ${
            this.state.isNavHidden ? "nav-hidden" : ""
          }`}
        >
          {this.state.availableMonths &&
            this.state.availableMonths.size > 0 && (
              <Fragment>
                <span>
                  {this.state.roundHistoryPerGame &&
                    `${this.state.roundHistoryPerGame.get("totalCount")} ${t(
                      "roundsIn",
                    )}`}
                  {!this.state.roundHistoryPerGame && (
                    <span className="dummy">loading loading</span>
                  )}
                </span>
                <span className="dropdown-container">
                  <Dropdown
                    availableMonths={this.state.availableMonths}
                    selectedMonth={
                      this.state.availableMonths &&
                      this.state.selectedMonthIndex !== null
                        ? this.state.availableMonths.getIn([
                            this.state.selectedMonthIndex,
                            "name",
                          ])
                        : ""
                    }
                    handleChange={this.handleMonthChange}
                  />
                </span>
              </Fragment>
            )}
          {!this.state.availableMonths && (
            <span className="dummy">loading loading</span>
          )}
        </div>
        <TableList
          list={this.state.roundHistoryPerGame}
          rowTestId="round-row"
          columnTestIds={{
            initiatedDate: "initiated",
            completedDate: "completed",
            status: "status",
            type: "type",
            totalBet: "total-bet",
            totalPayout: "total-payout",
          }}
          initiated={this.state.availableMonths && link ? true : false}
          isLoading={this.state.isLoading}
          listComplete={this.state.listComplete}
          onSort={this.onSort}
          onReachEnd={() => {
            let page = this.state.roundHistoryPerGame
              ? this.state.roundHistoryPerGame.get("page") + 1
              : null;
            this.fetchList(page);
          }}
          setLabel={(id) => {
            return this.setLabel(id);
          }}
          setValue={(item) => {
            return this.setValue(item);
          }}
          onRowClick={(item) => {
            if (isEqual(this.state.selectedItem, item)) {
              this.setState({
                selectedItem: null,
              });
            } else {
              this.setState({
                selectedItem: item,
              });
            }
            const link = item.get("links").find((link) => {
              return link.get("rel").indexOf("game-rounds.") > -1;
            });
            this.fetchGameRounds(link);
          }}
          /* setSkeleton={(key) => {
            return this.renderSkeleton(key);
          }}
          setHeaderSkeleton={(key) => {
            return this.renderHeaderSkeleton(key);
          }} */
          selectedItem={this.state.selectedItem}
          renderSelectedRow={this.renderSelectedRow}
          totalColumn={8}
          scrollIntoView={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  if (ownProps.isModal) {
    return {
      gameItem: ownProps.gameItem,
      roundHistoryLink: ownProps.roundHistoryLink,
      decimalPlaces: state.links.get("decimalPlaces"),
      isModal: true,
      onViewResultClick: ownProps.onViewResultClick,
    };
  }

  const sessionId = state.security.get("sessionId");
  const { item, modalRel, historyMonthId } = queryString.parse(
    (ownProps.location && ownProps.location.search) || window.location.search,
  );

  if (!sessionId || modalRel !== "round-history-per-game.links") return {};

  let itemObj;
  try {
    itemObj = fromJS(JSON.parse(decodeURIComponent(atob(item))));
  } catch (err) {}

  let RoundHistoryPerGameLink;
  try {
    RoundHistoryPerGameLink = itemObj
      .get("links")
      .find((link) => link.get("rel") === "round-history-per-game.links");
  } catch (err) {}

  return {
    modalRel,
    gameItem: itemObj,
    RoundHistoryPerGameLink,
    historyMonthId: historyMonthId || null,
    decimalPlaces: state.links.get("decimalPlaces"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
    fetchGameRoundHistoryPerGameRoute: (route) =>
      dispatchProps.fetchGameRoundHistoryPerGameRoute(route),
    setGameRoundHistoryPerGameRoute: (payload) =>
      dispatchProps.setGameRoundHistoryPerGameRoute(payload),
    fetchGameHistoryAvailableMonths: (route) =>
      dispatchProps.fetchGameHistoryAvailableMonths(route),
    setGameHistoryAvailableMonths: (payload) =>
      dispatchProps.setGameHistoryAvailableMonths(payload),
    fetchGameRoundHistoryPerGame: (route, params) =>
      dispatchProps.fetchGameRoundHistoryPerGame(route, params),
    fetchGameRounds: (link, params) =>
      dispatchProps.fetchGameRounds(link, params),
    setGameRounds: (payload) => dispatchProps.setGameRounds(payload),
    setGameRoundHistoryPerGame: (payload) =>
      dispatchProps.setGameRoundHistory(payload),
    navigateTo: (path) => ownProps.history.push(path),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
    setGameAction: (params) => dispatchProps.setGameAction(params),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withTranslation("translation")(RoundHistoryPerGame));
